<template>
  <SloLoader :loading="cartLoading" size="xl" :class="{'mt-lg': true, 'mb-lg': cartLoading}">
    <MarketplaceFullCart v-if="cartTotalUnitCount > 0" />
    <MarketplaceEmptyCart v-else />
  </SloLoader>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import SloLoader from '../../../lib/components/SloLoader.vue';
import MarketplaceEmptyCart from './MarketplaceEmptyCart.vue';
import MarketplaceFullCart from './MarketplaceFullCart.vue';

export default {
  components: {
    SloLoader,
    MarketplaceEmptyCart,
    MarketplaceFullCart
  },
  computed: {
    ...mapGetters('marketplace', ['cartTotalUnitCount']),
    ...mapState('marketplace', ['cartLoading'])
  },
  async mounted() {
    if (this.$route.query?.authenticate && !this.authenticated) {
      await this.$router.push({
        name: 'marketplace-auth-login',
        query: {redirect: '/marketplace/cart'}
      });
    }

    await this.getCurrentCart({references: true});
  },
  methods: mapActions('marketplace', ['getCurrentCart'])
};
</script>
